export const noop = () => {}
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { IButton } from '../uiParts/buttons'
import { buttons } from '../uiParts/buttons-sidecar'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { textInputs } from '../uiParts/textInputs-sidecar'
import { ITextInput } from '../uiParts/textInputs'

import { mapSaverShip } from '../tiles/mapSaverShip-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'

interface IData {
  isOpen: boolean
  dialog: dialogs.IDialog
  buttonCreate: IButton
  inputName: ITextInput
}

let _data: IData | null = null
export const getData = () => {
  if (!_data) {
    _data = {
      isOpen: false,
      dialog: dialogs.create(10, 5, 200, 50, 'Create Map', () => {
        console.log('clodse create 222')
        setOpen(false)
      }),
      buttonCreate: buttons.create(
        layers.getLayers().ui,
        200,
        150,
        'Create!',
        () => {
          mapSaverShip.saveLater()
          setOpen(false)
        },
      ),
      inputName: textInputs.create(
        layers.getLayers().ui,
        200,
        100,
        'new map',
        (newVal: string) => {
          mapSaverShip.setFilename(newVal)
        },
      ),
    }
    setOpen(false)
  }
  return _data
}

export const toggle = () => {
  setOpen(!getData().isOpen)
}

export const setOpen = async (isOpen: boolean) => {
  clickEater.update('uiNewMap', isOpen)

  let data = getData()

  data.isOpen = isOpen
  dialogs.setVisible(data.dialog, isOpen)
  buttons.setVisible(data.buttonCreate, isOpen)
  textInputs.setVisible(data.inputName, isOpen)
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
}
